export const WHATSAPP_NUMBER = '5493412252500'
export const PRIMARY_NUMBER = '3412252500'
export const WHATSAPP_DEFAULT_MESSAGE =
  'Hola Mobal, necesito un presupuesto para fumigación'
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_DEFAULT_MESSAGE)}`
export const SECONDARY_NUMBER = '341 676-3847'
export const DISPLAY_NUMBER = '3412 25-2500'
export const EMAIL = 'mobalfumigaciones@gmail.com'
export const LOGO_RECT =
  'https://cdn.magicpatterns.com/uploads/po35RgRvhg62paReXLxDcK/WhatsApp_Image_2026-04-22_at_15.52.13_(1).jpg'
export const LOGO_CIRC =
  'https://cdn.magicpatterns.com/uploads/e6ymY4fJhUDjKXDifs5kwz/WhatsApp_Image_2026-04-22_at_15.52.13.jpg'
